const steps = [
  {
    step: '01',
    title: 'Find Your Category',
    description: 'Browse through the organized category list and pick the one that matches what you are looking for. Each category links to curated product collections.',
  },
  {
    step: '02',
    title: 'Compare Products',
    description: 'Use the spreadsheet layout to compare multiple products side by side. Check specifications, styles, and details all in one view.',
  },
  {
    step: '03',
    title: 'Check Product Information',
    description: 'Review detailed product data including sizing, materials, and availability. Everything you need to make an informed choice.',
  },
  {
    step: '04',
    title: 'Make Informed Decisions',
    description: 'With all the information at your fingertips, choose the products that best fit your needs and budget. Smart shopping made simple.',
  },
];

export default function HowToUseSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-label font-semibold text-secondary-700 bg-secondary-100/80 rounded-full mb-3">
            Getting Started
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            How To Use VigorBuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Follow these four simple steps to make the most of your shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {steps.map((item, idx) => (
            <div key={item.step} className="relative">
              <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/50 h-full">
                <span className="inline-block text-3xl md:text-4xl font-heading font-bold text-secondary-300 mb-3">
                  {item.step}
                </span>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-6">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-secondary-300 text-xl"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}